module.exports = __webpack_public_path__ + "img/syukyaku-U-008-1.e9610024.png";